export const MEMORY_VERSION = "v0.19-memory";
